import { render, staticRenderFns } from "./frmPersona.vue?vue&type=template&id=4775a340&"
import script from "./frmPersona.vue?vue&type=script&lang=js&"
export * from "./frmPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports